<template>
  <DotsRL v-if="reverse" />
  <DotsLR v-else />
</template>

<script setup lang="ts">
import DotsLR from './Icons/DotsLR.vue'
import DotsRL from './Icons/DotsRL.vue'
defineProps({
  reverse: { type: Boolean, default: false },
})
</script>
